export class GmDealerEligibilityQueryParameters {
  APIKey?: string | null;
  BAC?: string | null;
  MemberEmail?: string | null;
  MemberNumber: string | null;
  RewardType?: string | null;
  SourceCode?: string | null;

  constructor(obj?: GmDealerEligibilityQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
